export default "__VITE_ASSET__23b722a1__"